import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import type { SelectChangeEvent } from '@mui/material/Select';
import Select from '@mui/material/Select';
import type { TSubmitFormAnswer } from '@onesource/schemas';
import { getDropdownOptions } from '@onesource/schemas';
import type { TFormQuestion } from '@onesource/services';

interface DropdownQuestionProps {
  question: TFormQuestion;
  answer: TSubmitFormAnswer;
  onAnswerChange: (answer: TSubmitFormAnswer) => void;
  disabled?: boolean;
}

export const DropdownQuestion = ({ question, answer, onAnswerChange, disabled = false }: DropdownQuestionProps) => {
  const options = getDropdownOptions(question.metadata);
  const value = answer.textAnswer ?? '';

  const handleChange = (e: SelectChangeEvent<string>) => {
    onAnswerChange({ ...answer, textAnswer: e.target.value });
  };

  return (
    <Box sx={{ p: 2, bgcolor: 'white', borderRadius: 2, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
      <FormControl fullWidth>
        <Select
          value={value}
          onChange={handleChange}
          disabled={disabled}
          displayEmpty
          sx={{
            bgcolor: '#fafafa',
            '& .MuiOutlinedInput-notchedOutline': { borderColor: '#ddd' },
            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#ff4d6d' },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#ff4d6d' },
          }}
        >
          <MenuItem value="" disabled>
            Select an option
          </MenuItem>
          {options.map(opt => (
            <MenuItem key={opt} value={opt}>
              {opt}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
